import { Component, OnInit } from '@angular/core';
import { TipRadneOpreme } from './tip-radne-opreme';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-tip-radne-opreme-update',
  templateUrl: './tip-radne-opreme-update.component.html'
})
export class TipRadneOpremeUpdateComponent extends BaseUpdateComponent<TipRadneOpreme> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    // this.addValidatorToFc("Naziv", Validators.required, 'required', 'TIPKOMITENTA.NAZIV.VALIDATION.REQUIRED');
    // this.addValidatorToFc("Naziv", Validators.maxLength(100), 'maxlength', 'TIPKOMITENTA.NAZIV.VALIDATION.MAXLENGTH');
  }

}
